module.exports = "<span><label>{{labelText}}</label><img style=\"padding-left:10px\" src=\"/assets/img/info.png\" pTooltip=\"{{infoText}}\"/></span>"